/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} News_Meta_Twitterdescription1Inputs */

const ja_news_meta_twitterdescription1 = /** @type {(inputs: News_Meta_Twitterdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAINからのお知らせ、ニュース、プレスリリースをご紹介します。東京を拠点に、日本・アジア市場向けゲームマーケティング、eスポーツ制作、クリエイティブサービスを提供しています。`)
};

const en_news_meta_twitterdescription1 = /** @type {(inputs: News_Meta_Twitterdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read the latest news, announcements, and press releases from PLAYBRAIN, a Tokyo-based game marketing agency specializing in Japan and Asia, esports production, gaming campaigns, and creative services.`)
};

/**
* | output |
* | --- |
* | "Read the latest news, announcements, and press releases from PLAYBRAIN, a Tokyo-based game marketing agency specializing in Japan and Asia, esports productio..." |
*
* @param {News_Meta_Twitterdescription1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const news_meta_twitterdescription1 = /** @type {((inputs?: News_Meta_Twitterdescription1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<News_Meta_Twitterdescription1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_news_meta_twitterdescription1(inputs)
	return en_news_meta_twitterdescription1(inputs)
});
export { news_meta_twitterdescription1 as "news_meta_twitterDescription" }